import React, {useState} from 'react'
import DeviceOnlineRate from './device-online-rate'
import DeviceManagementTime from './device-management-time'
import EnergyConsumption from './energy-consumption'
import DeviceWarningInfomation from './device-warning-infomation'
import GroupManagement from './group-management'
import EnergyBlock from './energy-block'
import swiperBg from '@assets/img/swiperBg.png'
import energyJump from '@assets/img/energyJump.png'
import './index.less'

export default function CockpitEnergyStatistics() {
  return (
    <div className="energy-block">
      <img src={swiperBg} className='energy-index-img'/>
      <div className='energy-index-item'>
        <div className='energy-index-top'>
          <div className='energy-index-left'>
            <EnergyConsumption />
            <DeviceWarningInfomation />
          </div>
          <div className='energy-index-center'>
            <GroupManagement />
          </div>
          <div className='energy-index-right'>
            <DeviceOnlineRate />
            <DeviceManagementTime />
          </div>
        </div>
        <div className='energy-index-bottom'>
          <EnergyBlock />
        </div>
      </div>
      <img className='energyJump' src={energyJump} onClick={() => {window.location.href= "http://" + window.location.hostname + ":20005/manage/electronic/deviceManagement"}}/>
    </div>
  )
}
